jQuery(function ($) {
    $('#testimony-slider').owlCarousel({
        loop:true,
        margin: 20,
        nav:false,
        dots: true,
        autoplay:true,
        animateOut: 'fadeOut',
        autoplayTimeout:4000,
        smartSpeed:1000,
        dragEndSpeed: 1000,
        autoplayHoverPause: false,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
        }
    })

    $('#banner-slider').owlCarousel({
        loop:true,
        margin: 0,
        nav:false,
        dots: false,
        autoplay:true,
        animateOut: 'fadeOut',
        autoplayTimeout:4000,
        smartSpeed:1000,
        dragEndSpeed: 1000,
        autoplayHoverPause: false,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
        }
    })

});